import { createActor } from 'xstate';

import { BaseChartStore } from 'features/base-chart-store';
import { SelectOption, NPSResponse } from 'types';

import { NPS } from '../nps.model';
import { NPSSerializer } from '../serializer';

export class NPSStore extends BaseChartStore<NPS, NPSResponse> {
  constructor(private serializer: NPSSerializer) {
    super('NPS Machine');
    // extend base chart machine if necessary
    this.service = createActor(this.machine);
    this.service.subscribe((state) => {
      this.current = state;
    });
    this.service.start();
  }

  protected async doFetch(
    therapists: Array<SelectOption<string>>,
    partnerId: string | undefined,
    partners: Array<SelectOption<string>>,
    clinics: Array<SelectOption<string>>,
    time: string,
    signal?: AbortSignal,
  ) {
    const jsonResponse = await this.load(
      'nps',
      {
        therapists,
        partnerId,
        partners,
        clinics,
        time,
      },
      signal,
    );

    return this.serializer.deserialize(jsonResponse);
  }
}
